interface GoogleConfig {
  API_KEY: string;
  CLIENT_ID: string;
  SECRET: string;
}

interface FacebookConfig {
  APP_ID: string;
}

interface ApiConfig {
  API_URL: string;
}

interface SeqConfig {
  SERVER_URL: string;
  API_KEY: string;
}

// Endpoint/bucket MinIO public (cùng bucket "pmxs" payout-service/ticket-service/system-service
// đang dùng) — chỉ dùng để GHÉP URL đọc trực tiếp file public (VD: DrawPrize/{issuancePlanId}.json
// do payout-service upload, xem DrawResultStorageService.cs), không phải để upload/ghi từ client.
interface MinioConfig {
  ENDPOINT: string;
  BUCKET_NAME: string;
}

interface Config {
  google: GoogleConfig;
  facebook: FacebookConfig;
  api: ApiConfig;
  seq: SeqConfig;
  minio: MinioConfig;
}

const config: Config = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    API_URL: process.env.REACT_APP_API_URL || "https://lms-api.exo.io.vn",
  },
  seq: {
    SERVER_URL: process.env.REACT_APP_SEQ_SERVER_URL || "http://103.82.28.113:5341",
    API_KEY: process.env.REACT_APP_SEQ_API_KEY || "",
  },
  minio: {
    ENDPOINT: process.env.REACT_APP_MINIO_ENDPOINT || "https://s3.vtcmobile.vn",
    BUCKET_NAME: process.env.REACT_APP_MINIO_BUCKET_NAME || "pmxs",
  },
};

export default config;
